import { useState } from "react";

export interface PaginationParams {
	per_page: number;
	page: number;
}

interface UsePaginationOptions {
	initialPage?: number;
	initialPerPage?: number;
}

function usePagination(options: UsePaginationOptions = {}) {
	const { initialPage = 1, initialPerPage = 15 } = options;

	const [currentPage, setCurrentPage] = useState(initialPage);
	const [perPage, setPerPage] = useState(initialPerPage);

	function resetToFirstPage() {
		setCurrentPage(1);
	}

	function handlePageChange(newPage: number) {
		setCurrentPage(newPage);
	}

	function handlePerPageChange(newPerPage: number) {
		setPerPage(newPerPage);
		resetToFirstPage();
	}

	function reset() {
		setCurrentPage(initialPage);
		setPerPage(initialPerPage);
	}

	return {
		// State
		currentPage,
		perPage,

		// Handlers
		handlePageChange,
		handlePerPageChange,
		resetToFirstPage,
		reset,

		// Computed values
		getPaginationParams: (): PaginationParams => ({
			page: currentPage,
			per_page: perPage,
		}),
	};
}

export { usePagination };
